import { CalendarIcon } from '@heroicons/react/20/solid';
import moment from 'moment-timezone';
import React from 'react';

type Props = {
  scheduled_for: string;
  onClick: () => void;
  className?: string;
};

export function ScheduledOrderTime({
  scheduled_for,
  onClick,
  className = 'mx-4 my-4',
}: Props) {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div className={`rounded-md bg-secondary-container p-4 ${className}`}>
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <CalendarIcon
            className="h-5 w-5 text-on-secondary-container"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3 flex flex-row items-center space-x-4">
          {scheduled_for === '' ? (
            <div
              className="rounded-md text-xs text-on-primary bg-primary px-1 py-0.5 cursor-pointer"
              onClick={() => {
                onClick();
              }}
            >
              Select Date & Time
            </div>
          ) : (
            <>
              {' '}
              <h3 className="text-sm font-medium text-on-secondary-container">{`Ordering for ${moment
                .utc(scheduled_for)
                .tz(tz)
                .format('lll')}`}</h3>
              <div
                className="rounded-md text-xs text-on-primary bg-primary px-1 py-0.5 cursor-pointer"
                onClick={() => {
                  onClick();
                }}
              >
                Change
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
